/*** IMPORTS FROM imports-loader ***/
(function() {

/* eslint-disable func-names, space-before-function-paren */

window.d3 = require('d3');

}.call(window));


// WEBPACK FOOTER //
// ./lib/d3.js